import mapErrorsToForm from '../mapErrorsToForm';

$('#feedbackForm').validate({
    rules: {
        name: 'required',
        email: 'required',
        message: 'required',
    },
    messages: {
        name: 'Enter valid name',
        email: 'Enter valid email',
        message: 'Enter valid message',
    },
    async submitHandler(form, e) {
        e.preventDefault();
        form = $(form);
        form.find('button').addClass('disable').prop('disabled', true);

        try {
            await axios.post(form.attr('action'), form.serialize());

            form
                .find('textarea[name="message"]')
                .after('<label id="message-error" style="color: #00ff38; font-weight: bold; font-size: 14px;" class="error">Thanks for your feed.</label>')
                .end()
                .find('textarea[name="message"]')
                .after('<label id="message-error" style="color: #00ff38; font-weight: bold; font-size: 14px;" class="error">We will do all to answer immediately, but sometimes it can take up to 6 hours.</label>');

            form.get(0).reset();
        } catch (e) {
            form.find('textarea[name="message"]').after('<label id="message-error" class="error">Form is not valid, please check</label>');
            mapErrorsToForm(form, e.response);
        } finally {
            form.find('button').removeClass('disable').prop('disabled', false);
        }
    }
});
